/**
 * A perk can be either points or an external reward program
 */

import { ReactNode } from "react";
import { classNames } from "../../utils/class-names";
import { PointsIcon } from "./points-icon";

const iconClassName = "w-4 h-4";

export const Perk = {
  Root,
  Label,
  Item,
  Emphasis,
  PointsLabel,
  RewardsLabel,
  iconClassName,
  SignalsRoot,
  PointsIcon,
};

interface RootProps {
  className?: string;
  children?: ReactNode;
}

function Root({ className, children }: RootProps): JSX.Element {
  return (
    <div
      className={classNames("flex flex-col gap-2.5 text-shale-200", className)}
    >
      {children}
    </div>
  );
}

interface SignalRootProps {
  className?: string;
  children?: ReactNode;
}

function SignalsRoot({ className, children }: SignalRootProps) {
  return (
    <div className={classNames("flex items-center gap-2.5", className)}>
      {children}
    </div>
  );
}

interface LabelProps {
  className?: string;
  children?: ReactNode;
}

const DEFAULT_LABEL_COPY = "You get additional:";

function Label({
  className,
  children = DEFAULT_LABEL_COPY,
}: LabelProps): JSX.Element {
  return <div className={classNames("", className)}>{children}</div>;
}

interface ItemProps {
  className?: string;
  children?: ReactNode;
}

function Item({ className, children }: ItemProps): JSX.Element {
  return (
    <div className={classNames("flex items-center gap-2.5", className)}>
      {children}
    </div>
  );
}

interface EmphasisProps {
  className?: string;
  children?: ReactNode;
}

function Emphasis({ className, children }: EmphasisProps) {
  return (
    <span className={classNames("font-medium text-white", className)}>
      {children}
    </span>
  );
}

interface PointsLabelProps {
  className?: string;
}

function PointsLabel({ className }: PointsLabelProps): JSX.Element {
  return <div className={classNames("text-shale-200", className)}>points</div>;
}

interface RewardsLabelProps {
  className?: string;
}

function RewardsLabel({ className }: RewardsLabelProps): JSX.Element {
  return <div className={classNames("text-shale-200", className)}>rewards</div>;
}
